module.exports = __webpack_public_path__ + "img/122.1.d766e365.jpg";